import { animate } from 'motion';

document.addEventListener('DOMContentLoaded', () => {
  const loadMoreButton = document.querySelector('.js-team-list-load-more');
  if (!loadMoreButton) return;

  loadMoreButton.addEventListener('click', () => {
    const list = loadMoreButton
      .closest('.b-team-list')
      .querySelector('.js-team-list-items');

    loadMoreButton.classList.add('is-loading');

    fetch(window.wpAjaxUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: 'action=load_more_team',
    })
      .then((response) => response.text())
      .then((data) => {
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = data;

        const newItems = Array.from(tempContainer.children);
        newItems.forEach((item, index) => {
          list.appendChild(item);
          animate(
            item,
            {
              opacity: [0, 1],
              y: [20, 0],
            },
            {
              duration: 0.3,
              delay: index * 0.1, // stagger effect
            },
          );
        });

        loadMoreButton.style.display = 'none';
      })
      .finally(() => {
        loadMoreButton.classList.remove('is-loading');
      });
  });
});
